import CostSimulator from './costSimulator'

const routes = [...CostSimulator]

export default routes
